import React from "react";
import { Link } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import AuthShell from "../../components/AuthShell/AuthShell";
import "../auth/auth.css";

function ForbiddenPage() {
    return (
        <AuthShell
            eyebrow="Console / Forbidden"
            title="Access denied."
            lede="This area is admin-only. You don't have permission to view it."
            footer={
                <Link
                    to="/dashboard"
                    className="auth-shell-link auth-shell-link--accent"
                >
                    Back to dashboard →
                </Link>
            }
        >
            <div className="auth-check auth-check--error">
                <div
                    className="auth-check__icon auth-check__icon--error"
                    aria-hidden="true"
                >
                    <ShieldOff size={20} />
                </div>
            </div>
        </AuthShell>
    );
}

export default ForbiddenPage;
